import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import type { MarineOrganizationAccess } from './AuthGate';
import { supabase } from './lib/supabase';
import ListingSalesCockpit from './ListingSalesCockpit2';

export default function ListingSalesCockpitBridge({organization}:{organization:MarineOrganizationAccess}){
  const [mount,setMount]=useState<HTMLElement|null>(null);
  const [listingId,setListingId]=useState('');
  const [canDraft,setCanDraft]=useState(organization.roles.includes('platform_admin'));

  useEffect(()=>{
    let cancelled=false;
    async function resolvePermissions(){
      if(!supabase||organization.roles.includes('platform_admin')){setCanDraft(true);return;}
      const {data:user}=await supabase!.auth.getUser();
      if(!user.user)return;
      const {data}=await supabase!.from('marine_organization_members').select('can_draft,role').eq('organization_id',organization.id).eq('user_id',user.user.id).eq('active',true).maybeSingle();
      if(!cancelled)setCanDraft(Boolean(data?.can_draft||['owner_admin','broker','broker_assistant'].includes(data?.role||'')));
    }
    resolvePermissions();
    return()=>{cancelled=true};
  },[organization.id]);

  useEffect(()=>{
    let cancelled=false;
    let currentCode='';
    async function inspect(){
      const hero=document.querySelector('.listing-detail-hero') as HTMLElement|null;
      if(!hero){if(!cancelled){setMount(null);setListingId('');}return;}
      const stack=hero.closest('.content-stack') as HTMLElement|null;
      if(!stack)return;
      let node=stack.querySelector(':scope > .listing-sales-cockpit-mount') as HTMLElement|null;
      if(!node){node=document.createElement('div');node.className='listing-sales-cockpit-mount';hero.insertAdjacentElement('afterend',node);}
      if(!cancelled)setMount(node);
      const code=(hero.querySelector('.eyebrow')?.textContent||'').trim();
      if(!code||code===currentCode||!supabase)return;
      currentCode=code;
      const {data}=await supabase.from('marine_listings').select('id').eq('organization_id',organization.id).eq('listing_code',code).maybeSingle();
      if(!cancelled)setListingId(data?.id||'');
    }
    inspect();
    const observer=new MutationObserver(()=>inspect());
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
    return()=>{cancelled=true;observer.disconnect();};
  },[organization.id]);

  async function openDocument(id:string){
    if(!supabase)return;
    const {data}=await supabase.from('marine_documents').select('title').eq('id',id).maybeSingle();
    const title=String(data?.title||'');
    const cards=Array.from(document.querySelectorAll('.approval-card')) as HTMLElement[];
    const card=cards.find(el=>el.textContent?.includes(title));
    (card?.querySelector('button') as HTMLButtonElement|null)?.click();
  }
  function newOffer(){
    const buttons=Array.from(document.querySelectorAll('.listing-detail-actions button')) as HTMLButtonElement[];
    buttons.find(b=>/new offer/i.test(b.textContent||''))?.click();
  }

  if(!mount||!listingId)return null;
  return createPortal(<ListingSalesCockpit organization={organization} listingId={listingId} canDraft={canDraft} onNewOffer={newOffer} onOpenDocument={openDocument}/>,mount);
}
